import {api} from 'api/setup';

export interface ClearCartRequest {
  product_ids: number[];
}

export interface ClearCartResponse {
  success: boolean;
  message?: string;
}

export const clearCartWithProducts = (data: ClearCartRequest): Promise<ClearCartResponse> => {
  return api.post(`/market-product/delete-image`, data);
};
